import { render } from "./BarMenu.vue?vue&type=template&id=475f488c&ts=true"
import script from "./BarMenu.vue?vue&type=script&lang=ts"
export * from "./BarMenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__